import {storeToRefs} from 'pinia';
import type {RouteLocationNormalized} from 'vue-router';
import {defineNuxtRouteMiddleware, navigateTo} from '#app';
import {useClientDetailsStore} from '~/features/invite-freelancer/client-details.store';

export default defineNuxtRouteMiddleware(async (to: RouteLocationNormalized) => {
    const {getClientInfos} = useClientDetailsStore();
    const {clientInfos} = storeToRefs(useClientDetailsStore());

    try {
        await getClientInfos();

        if (!clientInfos.value?.repatriationAllowed && to.params.id) {
            return navigateTo('/access-denied', {external: false});
        }
    } catch {
        navigateTo('/', {external: true});
    }
});
